/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  Category,
  CategoryHierarchyNode,
  ListerProductDTO,
  PdpProductAvailabilityDTO,
  PopularBrandsResource,
  PriceRange,
  ProductColourLinkFlatDTO,
  ProductManual,
  ProductPlacementCopyResource,
  ProductVariantDTO,
  ProductVideo,
  ProductWithComparisonFeatures,
  ProductWithFlattenedFeatures,
  StoreSourceExclusionSkuDTO,
  TechnicalCategory,
} from '@as-react/common-types/product-service';
import { faker } from '@faker-js/faker';
import { HttpResponse, delay, http } from 'msw';
import type { RequestHandlerOptions } from 'msw';

export const getGetHierarchyTreeForCategoriesServerResponseMock = (
  overrideResponse: Partial<CategoryHierarchyNode> = {}
): CategoryHierarchyNode => ({
  categoryPath: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  category: faker.helpers.arrayElement([
    {
      categoryId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      mainWebShopId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      market: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      mainWebShop: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      parentCategoryId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      linkType: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      hasSubLevels: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      flyoutColumn: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      sortOrder: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      categoryTranslatedProperties: faker.helpers.arrayElement([
        {
          [faker.string.alphanumeric(5)]: {
            languageCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
            description: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
            link: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
            genderMeta: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          },
        },
        undefined,
      ]),
      useForSuggest: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      useForFacet: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      navigationWeight: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      marketingWeight: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
    },
    undefined,
  ]),
  children: faker.helpers.arrayElement([
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      categoryPath: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      category: faker.helpers.arrayElement([
        {
          categoryId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          mainWebShopId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          market: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          mainWebShop: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          parentCategoryId: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          linkType: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          hasSubLevels: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          flyoutColumn: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          sortOrder: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          categoryTranslatedProperties: faker.helpers.arrayElement([
            {
              [faker.string.alphanumeric(5)]: {
                languageCode: faker.helpers.arrayElement([
                  faker.string.alpha({ length: { min: 10, max: 20 } }),
                  undefined,
                ]),
                description: faker.helpers.arrayElement([
                  faker.string.alpha({ length: { min: 10, max: 20 } }),
                  undefined,
                ]),
                link: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
                genderMeta: faker.helpers.arrayElement([
                  faker.string.alpha({ length: { min: 10, max: 20 } }),
                  undefined,
                ]),
              },
            },
            undefined,
          ]),
          useForSuggest: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          useForFacet: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          navigationWeight: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          marketingWeight: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
        },
        undefined,
      ]),
      children: faker.helpers.arrayElement([[], undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getGetProductByProductCodeWithFallbackServerResponseMock = (
  overrideResponse: Partial<ListerProductDTO | ListerProductDTO> = {}
): ListerProductDTO | ListerProductDTO =>
  faker.helpers.arrayElement([
    {
      productCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      productId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      colourId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      currency: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      availability: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      brandId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      brand: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      genderCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      title: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      seoUrl: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      type: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      colours: faker.helpers.arrayElement([
        Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
          colourId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          colourCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          availability: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          description: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          swatch: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          image: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          allColourImages: faker.helpers.arrayElement([
            Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() =>
              faker.string.alpha({ length: { min: 10, max: 20 } })
            ),
            undefined,
          ]),
          price: faker.helpers.arrayElement([
            {
              productDiscountPercentage: faker.helpers.arrayElement([
                faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
                undefined,
              ]),
              productDiscountAmount: faker.helpers.arrayElement([
                faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
                undefined,
              ]),
            },
            undefined,
          ]),
          prices: faker.helpers.arrayElement([
            {
              [faker.string.alphanumeric(5)]: {
                intPrice: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
                decPrice: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
                original: faker.helpers.arrayElement([
                  faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
                  undefined,
                ]),
                priceState: faker.helpers.arrayElement([
                  faker.string.alpha({ length: { min: 10, max: 20 } }),
                  undefined,
                ]),
              },
            },
            undefined,
          ]),
          priceOverlay: faker.helpers.arrayElement([
            {
              overlayCode: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              overlayThumb: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              idOverlayBackground: faker.helpers.arrayElement([
                faker.number.int({ min: undefined, max: undefined }),
                undefined,
              ]),
              overlayBackgroundCodeDescription: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
            },
            undefined,
          ]),
          hasDiscount: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          hasDifferentPrices: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          extendedRange: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          ccExcluded: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          markdown: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          sortOrder: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          alwaysVisible: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          newProduct: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          hoverImage: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          sizes: faker.helpers.arrayElement([
            Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
              active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
              sku: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
              code: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
              order: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
              commercialSize: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              commercialSizeDefault: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              commercialSizePrefix: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              commercialSizeSuffix: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              internalSizePrefix: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              internalSizeSuffix: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              unchangedCommercialSize: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              originalSize: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              availability: faker.helpers.arrayElement([
                faker.number.int({ min: undefined, max: undefined }),
                undefined,
              ]),
              fullCommercialSize: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              supplierSizeReference: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              storeSourceExcluded: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
              historicAvailable: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
              fulfillmentCopy: faker.helpers.arrayElement([
                {
                  [faker.string.alphanumeric(5)]: faker.string.alpha({ length: { min: 10, max: 20 } }),
                },
                undefined,
              ]),
            })),
            undefined,
          ]),
        })),
        undefined,
      ]),
      featureValueGenderId: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      impression: faker.helpers.arrayElement([
        {
          id: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          name: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          price: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          brand: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          category: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          variant: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        },
        undefined,
      ]),
      productRating: faker.helpers.arrayElement([
        faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
        undefined,
      ]),
      productReviews: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      defaultCategoryId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      sustainable: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      listerDescription: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      ourPlanet: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      ...overrideResponse,
    },
    {
      productCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      productId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      colourId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      currency: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      availability: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      brandId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      brand: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      genderCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      title: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      seoUrl: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      type: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      colours: faker.helpers.arrayElement([
        Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
          colourId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          colourCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          availability: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          description: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          swatch: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          image: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          allColourImages: faker.helpers.arrayElement([
            Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() =>
              faker.string.alpha({ length: { min: 10, max: 20 } })
            ),
            undefined,
          ]),
          price: faker.helpers.arrayElement([
            {
              productDiscountPercentage: faker.helpers.arrayElement([
                faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
                undefined,
              ]),
              productDiscountAmount: faker.helpers.arrayElement([
                faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
                undefined,
              ]),
            },
            undefined,
          ]),
          prices: faker.helpers.arrayElement([
            {
              [faker.string.alphanumeric(5)]: {
                intPrice: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
                decPrice: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
                original: faker.helpers.arrayElement([
                  faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
                  undefined,
                ]),
                priceState: faker.helpers.arrayElement([
                  faker.string.alpha({ length: { min: 10, max: 20 } }),
                  undefined,
                ]),
              },
            },
            undefined,
          ]),
          priceOverlay: faker.helpers.arrayElement([
            {
              overlayCode: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              overlayThumb: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              idOverlayBackground: faker.helpers.arrayElement([
                faker.number.int({ min: undefined, max: undefined }),
                undefined,
              ]),
              overlayBackgroundCodeDescription: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
            },
            undefined,
          ]),
          hasDiscount: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          hasDifferentPrices: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          extendedRange: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          ccExcluded: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          markdown: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          sortOrder: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          alwaysVisible: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          newProduct: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          hoverImage: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          sizes: faker.helpers.arrayElement([
            Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
              active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
              sku: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
              code: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
              order: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
              commercialSize: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              commercialSizeDefault: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              commercialSizePrefix: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              commercialSizeSuffix: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              internalSizePrefix: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              internalSizeSuffix: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              unchangedCommercialSize: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              originalSize: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              availability: faker.helpers.arrayElement([
                faker.number.int({ min: undefined, max: undefined }),
                undefined,
              ]),
              fullCommercialSize: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              supplierSizeReference: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              storeSourceExcluded: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
              historicAvailable: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
              fulfillmentCopy: faker.helpers.arrayElement([
                {
                  [faker.string.alphanumeric(5)]: faker.string.alpha({ length: { min: 10, max: 20 } }),
                },
                undefined,
              ]),
            })),
            undefined,
          ]),
        })),
        undefined,
      ]),
      featureValueGenderId: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      impression: faker.helpers.arrayElement([
        {
          id: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          name: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          price: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          brand: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          category: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          variant: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        },
        undefined,
      ]),
      productRating: faker.helpers.arrayElement([
        faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
        undefined,
      ]),
      productReviews: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      defaultCategoryId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      sustainable: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      listerDescription: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      ourPlanet: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      ...overrideResponse,
    },
  ]);

export const getGetProductByProductCodeAndColorWithFallbackServerResponseMock = (
  overrideResponse: Partial<ListerProductDTO | ListerProductDTO> = {}
): ListerProductDTO | ListerProductDTO =>
  faker.helpers.arrayElement([
    {
      productCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      productId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      colourId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      currency: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      availability: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      brandId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      brand: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      genderCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      title: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      seoUrl: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      type: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      colours: faker.helpers.arrayElement([
        Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
          colourId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          colourCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          availability: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          description: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          swatch: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          image: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          allColourImages: faker.helpers.arrayElement([
            Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() =>
              faker.string.alpha({ length: { min: 10, max: 20 } })
            ),
            undefined,
          ]),
          price: faker.helpers.arrayElement([
            {
              productDiscountPercentage: faker.helpers.arrayElement([
                faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
                undefined,
              ]),
              productDiscountAmount: faker.helpers.arrayElement([
                faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
                undefined,
              ]),
            },
            undefined,
          ]),
          prices: faker.helpers.arrayElement([
            {
              [faker.string.alphanumeric(5)]: {
                intPrice: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
                decPrice: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
                original: faker.helpers.arrayElement([
                  faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
                  undefined,
                ]),
                priceState: faker.helpers.arrayElement([
                  faker.string.alpha({ length: { min: 10, max: 20 } }),
                  undefined,
                ]),
              },
            },
            undefined,
          ]),
          priceOverlay: faker.helpers.arrayElement([
            {
              overlayCode: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              overlayThumb: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              idOverlayBackground: faker.helpers.arrayElement([
                faker.number.int({ min: undefined, max: undefined }),
                undefined,
              ]),
              overlayBackgroundCodeDescription: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
            },
            undefined,
          ]),
          hasDiscount: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          hasDifferentPrices: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          extendedRange: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          ccExcluded: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          markdown: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          sortOrder: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          alwaysVisible: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          newProduct: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          hoverImage: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          sizes: faker.helpers.arrayElement([
            Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
              active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
              sku: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
              code: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
              order: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
              commercialSize: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              commercialSizeDefault: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              commercialSizePrefix: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              commercialSizeSuffix: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              internalSizePrefix: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              internalSizeSuffix: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              unchangedCommercialSize: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              originalSize: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              availability: faker.helpers.arrayElement([
                faker.number.int({ min: undefined, max: undefined }),
                undefined,
              ]),
              fullCommercialSize: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              supplierSizeReference: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              storeSourceExcluded: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
              historicAvailable: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
              fulfillmentCopy: faker.helpers.arrayElement([
                {
                  [faker.string.alphanumeric(5)]: faker.string.alpha({ length: { min: 10, max: 20 } }),
                },
                undefined,
              ]),
            })),
            undefined,
          ]),
        })),
        undefined,
      ]),
      featureValueGenderId: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      impression: faker.helpers.arrayElement([
        {
          id: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          name: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          price: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          brand: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          category: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          variant: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        },
        undefined,
      ]),
      productRating: faker.helpers.arrayElement([
        faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
        undefined,
      ]),
      productReviews: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      defaultCategoryId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      sustainable: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      listerDescription: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      ourPlanet: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      ...overrideResponse,
    },
    {
      productCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      productId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      colourId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      currency: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      availability: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      brandId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      brand: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      genderCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      title: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      seoUrl: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      type: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      colours: faker.helpers.arrayElement([
        Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
          colourId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          colourCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          availability: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          description: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          swatch: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          image: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          allColourImages: faker.helpers.arrayElement([
            Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() =>
              faker.string.alpha({ length: { min: 10, max: 20 } })
            ),
            undefined,
          ]),
          price: faker.helpers.arrayElement([
            {
              productDiscountPercentage: faker.helpers.arrayElement([
                faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
                undefined,
              ]),
              productDiscountAmount: faker.helpers.arrayElement([
                faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
                undefined,
              ]),
            },
            undefined,
          ]),
          prices: faker.helpers.arrayElement([
            {
              [faker.string.alphanumeric(5)]: {
                intPrice: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
                decPrice: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
                original: faker.helpers.arrayElement([
                  faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
                  undefined,
                ]),
                priceState: faker.helpers.arrayElement([
                  faker.string.alpha({ length: { min: 10, max: 20 } }),
                  undefined,
                ]),
              },
            },
            undefined,
          ]),
          priceOverlay: faker.helpers.arrayElement([
            {
              overlayCode: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              overlayThumb: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              idOverlayBackground: faker.helpers.arrayElement([
                faker.number.int({ min: undefined, max: undefined }),
                undefined,
              ]),
              overlayBackgroundCodeDescription: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
            },
            undefined,
          ]),
          hasDiscount: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          hasDifferentPrices: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          extendedRange: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          ccExcluded: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          markdown: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          sortOrder: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          alwaysVisible: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          newProduct: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          hoverImage: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          sizes: faker.helpers.arrayElement([
            Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
              active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
              sku: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
              code: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
              order: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
              commercialSize: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              commercialSizeDefault: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              commercialSizePrefix: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              commercialSizeSuffix: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              internalSizePrefix: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              internalSizeSuffix: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              unchangedCommercialSize: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              originalSize: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              availability: faker.helpers.arrayElement([
                faker.number.int({ min: undefined, max: undefined }),
                undefined,
              ]),
              fullCommercialSize: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              supplierSizeReference: faker.helpers.arrayElement([
                faker.string.alpha({ length: { min: 10, max: 20 } }),
                undefined,
              ]),
              storeSourceExcluded: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
              historicAvailable: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
              fulfillmentCopy: faker.helpers.arrayElement([
                {
                  [faker.string.alphanumeric(5)]: faker.string.alpha({ length: { min: 10, max: 20 } }),
                },
                undefined,
              ]),
            })),
            undefined,
          ]),
        })),
        undefined,
      ]),
      featureValueGenderId: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      impression: faker.helpers.arrayElement([
        {
          id: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          name: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          price: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          brand: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          category: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          variant: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        },
        undefined,
      ]),
      productRating: faker.helpers.arrayElement([
        faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
        undefined,
      ]),
      productReviews: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      defaultCategoryId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      sustainable: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      listerDescription: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      ourPlanet: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      ...overrideResponse,
    },
  ]);

export const getGetProductFeaturesComparisonResponseMock = (
  overrideResponse: Partial<ProductWithComparisonFeatures> = {}
): ProductWithComparisonFeatures => ({
  productId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  mainWebShopId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  market: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  features: faker.helpers.arrayElement([
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      featureId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      featureCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      featureApplication: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      featureType: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      featureLabel: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      languageId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      attributeValueId: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      attributeValue: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getGetProductFeaturesComparisonServerResponseMock = (
  overrideResponse: Partial<ProductWithComparisonFeatures> = {}
): ProductWithComparisonFeatures => ({
  productId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  mainWebShopId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  market: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  features: faker.helpers.arrayElement([
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      featureId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      featureCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      featureApplication: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      featureType: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      featureLabel: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      languageId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      attributeValueId: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      attributeValue: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getGetProductVariantsByProductCodeServerResponseMock = (): Array<ProductVariantDTO> =>
  Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    variantType: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
    productCodeVariants: faker.helpers.arrayElement([
      Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
        productCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        variantValue: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        productSeoUrl: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        colorId: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        availability: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      })),
      undefined,
    ]),
    availability: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  }));

export const getGetProductExclusionsServerResponseMock = (): Array<StoreSourceExclusionSkuDTO> =>
  Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    skuId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
    storeSourceExcluded: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
    fulfillmentCopy: faker.helpers.arrayElement([
      {
        [faker.string.alphanumeric(5)]: faker.string.alpha({ length: { min: 10, max: 20 } }),
      },
      undefined,
    ]),
  }));

export const getGetPopularBrandsServerResponseMock = (
  overrideResponse: Partial<PopularBrandsResource> = {}
): PopularBrandsResource => ({
  popularBrands: faker.helpers.arrayElement([
    {
      [faker.string.alphanumeric(5)]: faker.number.int({ min: undefined, max: undefined }),
    },
    undefined,
  ]),
  ...overrideResponse,
});

export const getGetProductByProductCodeResponseMock = (
  overrideResponse: Partial<ListerProductDTO> = {}
): ListerProductDTO => ({
  productCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  productId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  colourId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  currency: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  availability: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  brandId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  brand: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  genderCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  title: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  seoUrl: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  type: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  colours: faker.helpers.arrayElement([
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      colourId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      colourCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      availability: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      description: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      swatch: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      image: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      allColourImages: faker.helpers.arrayElement([
        Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() =>
          faker.string.alpha({ length: { min: 10, max: 20 } })
        ),
        undefined,
      ]),
      price: faker.helpers.arrayElement([
        {
          productDiscountPercentage: faker.helpers.arrayElement([
            faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
            undefined,
          ]),
          productDiscountAmount: faker.helpers.arrayElement([
            faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
            undefined,
          ]),
        },
        undefined,
      ]),
      prices: faker.helpers.arrayElement([
        {
          [faker.string.alphanumeric(5)]: {
            intPrice: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
            decPrice: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
            original: faker.helpers.arrayElement([
              faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
              undefined,
            ]),
            priceState: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          },
        },
        undefined,
      ]),
      priceOverlay: faker.helpers.arrayElement([
        {
          overlayCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          overlayThumb: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          idOverlayBackground: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          overlayBackgroundCodeDescription: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
        },
        undefined,
      ]),
      hasDiscount: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      hasDifferentPrices: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      extendedRange: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      ccExcluded: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      markdown: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      sortOrder: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      alwaysVisible: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      newProduct: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      hoverImage: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      sizes: faker.helpers.arrayElement([
        Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
          active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          sku: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          code: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          order: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          commercialSize: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          commercialSizeDefault: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          commercialSizePrefix: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          commercialSizeSuffix: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          internalSizePrefix: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          internalSizeSuffix: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          unchangedCommercialSize: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          originalSize: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          availability: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          fullCommercialSize: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          supplierSizeReference: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          storeSourceExcluded: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          historicAvailable: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          fulfillmentCopy: faker.helpers.arrayElement([
            {
              [faker.string.alphanumeric(5)]: faker.string.alpha({ length: { min: 10, max: 20 } }),
            },
            undefined,
          ]),
        })),
        undefined,
      ]),
    })),
    undefined,
  ]),
  featureValueGenderId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  impression: faker.helpers.arrayElement([
    {
      id: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      name: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      price: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      brand: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      category: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      variant: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
    },
    undefined,
  ]),
  productRating: faker.helpers.arrayElement([
    faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
    undefined,
  ]),
  productReviews: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  defaultCategoryId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  sustainable: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  listerDescription: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ourPlanet: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getGetProductByProductCodeServerResponseMock = (
  overrideResponse: Partial<ListerProductDTO> = {}
): ListerProductDTO => ({
  productCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  productId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  colourId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  currency: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  availability: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  brandId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  brand: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  genderCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  title: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  seoUrl: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  type: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  colours: faker.helpers.arrayElement([
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      colourId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      colourCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      availability: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      description: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      swatch: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      image: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      allColourImages: faker.helpers.arrayElement([
        Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() =>
          faker.string.alpha({ length: { min: 10, max: 20 } })
        ),
        undefined,
      ]),
      price: faker.helpers.arrayElement([
        {
          productDiscountPercentage: faker.helpers.arrayElement([
            faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
            undefined,
          ]),
          productDiscountAmount: faker.helpers.arrayElement([
            faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
            undefined,
          ]),
        },
        undefined,
      ]),
      prices: faker.helpers.arrayElement([
        {
          [faker.string.alphanumeric(5)]: {
            intPrice: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
            decPrice: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
            original: faker.helpers.arrayElement([
              faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
              undefined,
            ]),
            priceState: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          },
        },
        undefined,
      ]),
      priceOverlay: faker.helpers.arrayElement([
        {
          overlayCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          overlayThumb: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          idOverlayBackground: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          overlayBackgroundCodeDescription: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
        },
        undefined,
      ]),
      hasDiscount: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      hasDifferentPrices: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      extendedRange: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      ccExcluded: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      markdown: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      sortOrder: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      alwaysVisible: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      newProduct: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      hoverImage: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      sizes: faker.helpers.arrayElement([
        Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
          active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          sku: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          code: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          order: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          commercialSize: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          commercialSizeDefault: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          commercialSizePrefix: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          commercialSizeSuffix: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          internalSizePrefix: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          internalSizeSuffix: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          unchangedCommercialSize: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          originalSize: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          availability: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          fullCommercialSize: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          supplierSizeReference: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          storeSourceExcluded: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          historicAvailable: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          fulfillmentCopy: faker.helpers.arrayElement([
            {
              [faker.string.alphanumeric(5)]: faker.string.alpha({ length: { min: 10, max: 20 } }),
            },
            undefined,
          ]),
        })),
        undefined,
      ]),
    })),
    undefined,
  ]),
  featureValueGenderId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  impression: faker.helpers.arrayElement([
    {
      id: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      name: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      price: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      brand: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      category: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      variant: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
    },
    undefined,
  ]),
  productRating: faker.helpers.arrayElement([
    faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
    undefined,
  ]),
  productReviews: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  defaultCategoryId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  sustainable: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  listerDescription: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ourPlanet: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getGetProductVideoByIdServerResponseMock = (): Array<ProductVideo> =>
  Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    market: faker.string.alpha({ length: { min: 10, max: 20 } }),
    mainWebShopId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
    productId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
    videoId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
    active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
    productVideoByLanguage: faker.helpers.arrayElement([
      {
        [faker.string.alphanumeric(5)]: {
          languageCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          title: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          url: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          videoFormat: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          showOnWebsite: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          content: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          priority: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          alignment: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          subtitle: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          pictureRank: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          videoMode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          videoTypeCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          length: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          image: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        },
      },
      undefined,
    ]),
    productVideoDetail: faker.helpers.arrayElement([
      {
        languageCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        title: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        url: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        videoFormat: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        showOnWebsite: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
        content: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        priority: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
        alignment: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        subtitle: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        pictureRank: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
        videoMode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        videoTypeCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        length: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
        image: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      },
      undefined,
    ]),
  }));

export const getGetProductManualByIdServerResponseMock = (
  overrideResponse: Partial<ProductManual> = {}
): ProductManual => ({
  market: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  productId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  productManualByLanguage: faker.helpers.arrayElement([
    {
      [faker.string.alphanumeric(5)]: {
        languageCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        document: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        description: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        documentName: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        showOnWebsite: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      },
    },
    undefined,
  ]),
  ...overrideResponse,
});

export const getGetLinkedProductsByIdServerResponseMock = (): Array<ProductColourLinkFlatDTO> =>
  Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    market: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
    mainWebShopId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
    productId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
    fictionalShopId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
    productColourId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
    linkedProductId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
    linkedProductCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
    linkedProductColourId: faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      undefined,
    ]),
    linkedColourId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
    linkedFictionalShopId: faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      undefined,
    ]),
    linkTypeId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
    linkTypeCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
    active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
    sortOrder: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  }));

export const getGetProductTechnicalCategoriesByIdServerResponseMock = (): Array<TechnicalCategory> =>
  Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
    categoryCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
    categoryId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
    categoryName: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
    categoryRank: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
    features: faker.helpers.arrayElement([
      Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
        featureId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
        featureCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        featureType: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        featureName: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        featureValue: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        featureRank: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      })),
      undefined,
    ]),
  }));

export const getGetProductPlacementCopyByIdServerResponseMock = (
  overrideResponse: Partial<ProductPlacementCopyResource> = {}
): ProductPlacementCopyResource => ({
  productId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  mainWebShopId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  fictionalShopId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  market: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  colours: faker.helpers.arrayElement([
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      colourId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      positions: faker.helpers.arrayElement([
        Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
          active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          sortOrder: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          highlight: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          allShops: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          placementPositionId: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          overlayPosition: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          startDate: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]),
          endDate: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]),
          languageId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          languageCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          name: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          text: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        })),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getGetVoucherMinMaxAmountServerResponseMock = (
  overrideResponse: Partial<PriceRange> = {}
): PriceRange => ({
  minAmount: faker.helpers.arrayElement([
    faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
    undefined,
  ]),
  maxAmount: faker.helpers.arrayElement([
    faker.number.float({ min: undefined, max: undefined, fractionDigits: 2 }),
    undefined,
  ]),
  currency: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  ...overrideResponse,
});

export const getGetProductTechnicalFeaturesFlattenedServerResponseMock = (
  overrideResponse: Partial<ProductWithFlattenedFeatures> = {}
): ProductWithFlattenedFeatures => ({
  productId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  mainWebShopId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  market: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  features: faker.helpers.arrayElement([
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      featureId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      featureCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      featureType: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      featureValue: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getGetProductAvailabilityByIdServerResponseMock = (
  overrideResponse: Partial<PdpProductAvailabilityDTO> = {}
): PdpProductAvailabilityDTO => ({
  productId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  fictionalId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  availability: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  alwaysVisible: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  colorAvailabilities: faker.helpers.arrayElement([
    Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
      colorId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      availability: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
      alwaysVisible: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      skuAvailabilities: faker.helpers.arrayElement([
        Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({
          skuCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
          availability: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
          lastPieces: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
          exactAvailability: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
        })),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getGetCategoryByIdServerResponseMock = (overrideResponse: Partial<Category> = {}): Category => ({
  categoryId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  mainWebShopId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  market: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  mainWebShop: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  parentCategoryId: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  linkType: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
  hasSubLevels: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  flyoutColumn: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  sortOrder: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  categoryTranslatedProperties: faker.helpers.arrayElement([
    {
      [faker.string.alphanumeric(5)]: {
        languageCode: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        description: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        link: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
        genderMeta: faker.helpers.arrayElement([faker.string.alpha({ length: { min: 10, max: 20 } }), undefined]),
      },
    },
    undefined,
  ]),
  useForSuggest: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  useForFacet: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  navigationWeight: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  marketingWeight: faker.helpers.arrayElement([faker.number.int({ min: undefined, max: undefined }), undefined]),
  ...overrideResponse,
});

export const getGetHierarchyTreeForCategoriesServerMockHandler = (
  overrideResponse?:
    | CategoryHierarchyNode
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<CategoryHierarchyNode> | CategoryHierarchyNode),
  options?: RequestHandlerOptions
) => {
  return http.post(
    '*/cache/category/:market/hierarchy/:mainWebShopId/tree',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetHierarchyTreeForCategoriesServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetProductByProductCodeWithFallbackServerMockHandler = (
  overrideResponse?:
    | ListerProductDTO
    | ListerProductDTO
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<ListerProductDTO | ListerProductDTO> | ListerProductDTO | ListerProductDTO),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/public/enrichedproduct/productcode/fallback/:mainWebshop/:productCode',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetProductByProductCodeWithFallbackServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetProductByProductCodeAndColorWithFallbackServerMockHandler = (
  overrideResponse?:
    | ListerProductDTO
    | ListerProductDTO
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<ListerProductDTO | ListerProductDTO> | ListerProductDTO | ListerProductDTO),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/public/enrichedproduct/productcode/fallback/:mainWebshop/:productCode/:colorId',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetProductByProductCodeAndColorWithFallbackServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetProductFeaturesComparisonMockHandler = (
  overrideResponse?:
    | ProductWithComparisonFeatures
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<ProductWithComparisonFeatures> | ProductWithComparisonFeatures),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/api/aem/product/features/comparison/:market/:mainWebShopId/:productId',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetProductFeaturesComparisonResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetProductFeaturesComparisonServerMockHandler = (
  overrideResponse?:
    | ProductWithComparisonFeatures
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<ProductWithComparisonFeatures> | ProductWithComparisonFeatures),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/public/cache/product/features/comparison/:market/:mainWebShopId/:productId',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetProductFeaturesComparisonServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetProductVariantsByProductCodeServerMockHandler = (
  overrideResponse?:
    | Array<ProductVariantDTO>
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<Array<ProductVariantDTO>> | Array<ProductVariantDTO>),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/productvariant/:productCode/:market/:language/:shop',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetProductVariantsByProductCodeServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetProductExclusionsServerMockHandler = (
  overrideResponse?:
    | Array<StoreSourceExclusionSkuDTO>
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<Array<StoreSourceExclusionSkuDTO>> | Array<StoreSourceExclusionSkuDTO>),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/product/exclusions/:market/:mainWebShopId/:fictiveWebShopId/:productId',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetProductExclusionsServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetPopularBrandsServerMockHandler = (
  overrideResponse?:
    | PopularBrandsResource
    | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PopularBrandsResource> | PopularBrandsResource),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/popularbrand',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetPopularBrandsServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetProductByProductCodeMockHandler = (
  overrideResponse?:
    | ListerProductDTO
    | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListerProductDTO> | ListerProductDTO),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/api/aem/product/productcode',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetProductByProductCodeResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetProductByProductCodeServerMockHandler = (
  overrideResponse?:
    | ListerProductDTO
    | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ListerProductDTO> | ListerProductDTO),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/enrichedproduct/productcode',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetProductByProductCodeServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetProductVideoByIdServerMockHandler = (
  overrideResponse?:
    | Array<ProductVideo>
    | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<Array<ProductVideo>> | Array<ProductVideo>),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/cache/productvideo/:productId',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetProductVideoByIdServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetProductManualByIdServerMockHandler = (
  overrideResponse?:
    | ProductManual
    | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ProductManual> | ProductManual),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/cache/productmanual/:productId',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetProductManualByIdServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetLinkedProductsByIdServerMockHandler = (
  overrideResponse?:
    | Array<ProductColourLinkFlatDTO>
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<Array<ProductColourLinkFlatDTO>> | Array<ProductColourLinkFlatDTO>),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/cache/productcolour/links/:market/:mainWebShopId/:productId/:fictiveWebShopId/:productColourId',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetLinkedProductsByIdServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetProductTechnicalCategoriesByIdServerMockHandler = (
  overrideResponse?:
    | Array<TechnicalCategory>
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<Array<TechnicalCategory>> | Array<TechnicalCategory>),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/cache/product/technical/features/colours/categories/:market/:mainWebShopId/:productId/:colourId',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetProductTechnicalCategoriesByIdServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetProductPlacementCopyByIdServerMockHandler = (
  overrideResponse?:
    | ProductPlacementCopyResource
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<ProductPlacementCopyResource> | ProductPlacementCopyResource),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/cache/product/ppc/:mainWebShop/:fictionalShopId/:productId',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetProductPlacementCopyByIdServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetVoucherMinMaxAmountServerMockHandler = (
  overrideResponse?:
    | PriceRange
    | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<PriceRange> | PriceRange),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/cache/product/minmax',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetVoucherMinMaxAmountServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetProductTechnicalFeaturesFlattenedServerMockHandler = (
  overrideResponse?:
    | ProductWithFlattenedFeatures
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<ProductWithFlattenedFeatures> | ProductWithFlattenedFeatures),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/cache/product/features/:market/:mainWebShopId/:productId/flattened',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetProductTechnicalFeaturesFlattenedServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetProductAvailabilityByIdServerMockHandler = (
  overrideResponse?:
    | PdpProductAvailabilityDTO
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<PdpProductAvailabilityDTO> | PdpProductAvailabilityDTO),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/cache/product/availability/pdp/:mainWebShop/:productId',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetProductAvailabilityByIdServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetCategoryByIdServerMockHandler = (
  overrideResponse?: Category | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<Category> | Category),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/cache/category/:market/:categoryId/:mainWebShopId',
    async info => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetCategoryByIdServerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};
export const getOpenAPIDefinitionMock = () => [
  getGetHierarchyTreeForCategoriesServerMockHandler(),
  getGetProductByProductCodeWithFallbackServerMockHandler(),
  getGetProductByProductCodeAndColorWithFallbackServerMockHandler(),
  getGetProductFeaturesComparisonMockHandler(),
  getGetProductFeaturesComparisonServerMockHandler(),
  getGetProductVariantsByProductCodeServerMockHandler(),
  getGetProductExclusionsServerMockHandler(),
  getGetPopularBrandsServerMockHandler(),
  getGetProductByProductCodeMockHandler(),
  getGetProductByProductCodeServerMockHandler(),
  getGetProductVideoByIdServerMockHandler(),
  getGetProductManualByIdServerMockHandler(),
  getGetLinkedProductsByIdServerMockHandler(),
  getGetProductTechnicalCategoriesByIdServerMockHandler(),
  getGetProductPlacementCopyByIdServerMockHandler(),
  getGetVoucherMinMaxAmountServerMockHandler(),
  getGetProductTechnicalFeaturesFlattenedServerMockHandler(),
  getGetProductAvailabilityByIdServerMockHandler(),
  getGetCategoryByIdServerMockHandler(),
];
